import { Badge, Card, Group, List, Table, Text, Title } from '@mantine/core';
import classes from './InvoiceDomains.module.css';

const integrationState = (integrationActive) => {
  if (integrationActive === true) {
    return { label: 'Integration active', color: 'green', highlight: false };
  }
  if (integrationActive === false) {
    return { label: 'Not integration-active', color: 'red', highlight: true };
  }
  return { label: 'Never set', color: 'orange', highlight: true };
};

const InvoiceDomains = ({ domains, lineItems }) => {
  if (!domains?.length) {
    return null;
  }

  return (
    <Card withBorder mt="md">
      <Card.Section inheritPadding py="sm">
        <Title order={4}>Domains on this invoice</Title>
        <Text size="sm" c="dimmed" mb="sm">
          Every billable domain is invoiced regardless of its integration state. Check the highlighted rows before
          sending the invoice.
        </Text>
        <Table withTableBorder>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>Domain</Table.Th>
              <Table.Th>Integration</Table.Th>
              <Table.Th>Lines</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {domains.map((domain) => {
              const state = integrationState(domain.integrationActive);
              const lines = (lineItems ?? []).filter(
                (lineItem) => String(lineItem.domainId) === String(domain.id)
              );
              return (
                <Table.Tr key={domain.id} className={state.highlight ? classes.notIntegrationActive : undefined}>
                  <Table.Td>
                    <Group gap="xs">
                      <Text span fw={700}>
                        {domain.name}
                      </Text>
                      <Text span size="xs" c="dimmed">
                        #{domain.id}
                      </Text>
                    </Group>
                  </Table.Td>
                  <Table.Td>
                    <Badge variant="light" color={state.color}>
                      {state.label}
                    </Badge>
                  </Table.Td>
                  <Table.Td>
                    {lines.length > 0 ? (
                      <List size="sm">
                        {lines.map((lineItem, i) => (
                          <List.Item key={i}>{lineItem.description}</List.Item>
                        ))}
                      </List>
                    ) : (
                      <Text span size="sm" c="dimmed">
                        No lines attributed
                      </Text>
                    )}
                  </Table.Td>
                </Table.Tr>
              );
            })}
          </Table.Tbody>
        </Table>
      </Card.Section>
    </Card>
  );
};

export default InvoiceDomains;
